var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4802 14.657L30.9148 12.973L30.2911 12.5156L31.289 11.6008L30.5197 11.0187L31.5177 10.2703L30.8732 9.77131L31.9127 4.69854L30.3326 0M30.3326 0L20.1871 3.76299H11.7256L1.58004 0L0 4.69854L1.06029 9.77131L0.39501 10.2703L1.41372 11.0187L0.644491 11.6008L1.64241 12.5156L1.01871 12.973L2.45322 14.657L0.27027 21.3929L2.2869 28.2744L9.3763 26.3202L10.7484 27.4428L13.5551 29.3555H18.3576L21.1642 27.4428L22.5364 26.3202L29.6466 28.2744L31.684 21.3929L29.4802 14.657",
    fill: "#F5841F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3326 0L17.8794 9.1684L20.1871 3.76299L30.3326 0Z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58008 0L13.9294 9.25156L11.7256 3.76299L1.58008 0Z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.863 21.2681L22.5366 26.2993L29.6468 28.2535L31.6842 21.372L25.863 21.2681Z",
    fill: "#E27625"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.270508 21.372L2.28714 28.2535L9.37654 26.2993L6.07092 21.2681L0.270508 21.372Z",
    fill: "#E27625"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00191 12.7441L7.02686 15.7171L14.0539 16.0289L13.8252 8.50293L9.00191 12.7441Z",
    fill: "#E27625"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9314 12.7442L18.0249 8.41992L17.8794 16.0291L24.9064 15.7172L22.9314 12.7442Z",
    fill: "#E27625"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37646 26.2994L13.6384 24.262L9.95859 21.4346L9.37646 26.2994Z",
    fill: "#E27625"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2954 24.262L22.5366 26.2994L21.9545 21.4346L18.2954 24.262Z",
    fill: "#E27625"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5366 26.2991L18.2954 24.2617L18.6488 27.006L18.6073 28.1702L22.5366 26.2991Z",
    fill: "#D7C1B3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37646 26.2991L13.3266 28.1702L13.3058 27.006L13.6384 24.2617L9.37646 26.2991Z",
    fill: "#D7C1B3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.389 19.605L9.87549 18.5863L12.3703 17.4429L13.389 19.605Z",
    fill: "#2F343B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5239 19.605L19.5634 17.4429L22.0582 18.5863L18.5239 19.605Z",
    fill: "#2F343B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37641 26.2993L10.0001 21.2681L6.0708 21.372L9.37641 26.2993Z",
    fill: "#CC6228"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9336 21.2681L22.5365 26.2993L25.8629 21.372L21.9336 21.2681Z",
    fill: "#CC6228"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9064 15.7173L17.8794 16.0291L18.5239 19.605L19.5634 17.4429L22.0582 18.5863L24.9064 15.7173Z",
    fill: "#CC6228"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87509 18.5863L12.3699 17.4429L13.3886 19.605L14.0539 16.0291L7.02686 15.7173L9.87509 18.5863Z",
    fill: "#CC6228"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02686 15.7173L9.95825 21.4345L9.87509 18.5863L7.02686 15.7173Z",
    fill: "#E27625"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0581 18.5863L21.9541 21.4345L24.9063 15.7173L22.0581 18.5863Z",
    fill: "#E27625"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 16.0293L13.3887 19.6052L14.2203 23.8463L14.4074 18.2746L14.054 16.0293Z",
    fill: "#E27625"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8793 16.0293L17.5259 18.2538L17.6922 23.8463L18.5238 19.6052L17.8793 16.0293Z",
    fill: "#E27625"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.524 19.6051L17.6924 23.8463L18.2953 24.2621L21.9543 21.4347L22.0583 18.5864L18.524 19.6051Z",
    fill: "#F5841F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87549 18.5864L9.95865 21.4347L13.6385 24.2621L14.2206 23.8463L13.389 19.6051L9.87549 18.5864Z",
    fill: "#F5841F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6072 28.1704L18.6488 27.0062L18.3162 26.7359H13.5968L13.3058 27.0062L13.3266 28.1704L9.37646 26.2993L10.7486 27.422L13.5553 29.3554H18.3578L21.1644 27.422L22.5365 26.2993L18.6072 28.1704Z",
    fill: "#C0AD9E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2953 24.262L17.6924 23.8462H14.2204L13.6383 24.262L13.3057 27.0063L13.5967 26.736H18.3161L18.6487 27.0063L18.2953 24.262Z",
    fill: "#2F343B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8734 9.77131L31.9129 4.69854L30.3328 0L18.2954 8.85655L22.9316 12.7443L29.4804 14.657L30.915 12.973L30.2913 12.5156L31.2892 11.6216L30.5199 11.0187L31.5179 10.2703L30.8734 9.77131Z",
    fill: "#763E1A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.69854L1.06029 9.77131L0.39501 10.2703L1.39293 11.0395L0.623701 11.6216L1.62162 12.5156L0.997921 12.973L2.45322 14.657L9.00208 12.7443L13.6383 8.85655L1.58004 0L0 4.69854Z",
    fill: "#763E1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4801 14.6568L22.9312 12.7441L24.9063 15.7171L21.9541 21.4344L25.8626 21.372H31.6838L29.4801 14.6568Z",
    fill: "#F5841F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00232 12.7441L2.45346 14.6568L0.270508 21.372H6.07092L9.95866 21.4344L7.02726 15.7171L9.00232 12.7441Z",
    fill: "#F5841F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8794 16.0293L18.2952 8.85674L20.1871 3.76318H11.7256L13.6383 8.85674L14.0541 16.0293L14.2204 18.2746V23.8463H17.6923L17.7131 18.2746L17.8794 16.0293Z",
    fill: "#F5841F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.d3efc1247fbe9dd1efd447149a6b34ed.svg";
export { ForwardRef as ReactComponent };